<script>
export default {
  name: 'HRender',
  props: {
    fn: Function
  },
  render (h) {
    return this.fn(h, this.$attrs)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/H.vue